import React from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import Select from 'react-select';
import moment from 'moment';

// Styles
import { FormStyled, Row, Column } from '../../../css/styles/form';
import { SelectStyled } from '../../../css/styles/select';

const handleValidate = ({ technicalReport }) => {
  const errors = {};

  if (!technicalReport || !technicalReport.uuid) {
    errors.technicalReport = 'OBRIGATÓRIO';
  }

  return errors;
};

const handleSubmit = props => async (values, { setSubmitting, resetForm }) => {
  console.log('submit:', values);
  if (props.maintenanceTechnicalReport) {
    await props.onUpdate({ ...values });
  } else {
    await props.onCreation({ ...values });
  }

  setSubmitting(false);
  resetForm();
};

const MaintenanceTechnicalReportForm = props => {
  const {
    onNew,
    technicalReports,
    technicalReport,
    maintenanceTechnicalReport,
  } = props;

  return (
    <Formik
      enableReinitialize
      initialValues={{
        technicalReport: maintenanceTechnicalReport
          ? maintenanceTechnicalReport.technicalreport
          : technicalReport || null,
      }}
      validate={handleValidate}
      onSubmit={handleSubmit(props)}
    >
      {({
        values,
        handleReset,
        handleBlur,
        handleChange,
        errors,
        touched,
        setFieldValue,
        isSubmitting,
        dirty,
      }) => (
        <FormStyled>
          <h1>
            {maintenanceTechnicalReport
              ? 'ALTERAR RELATÓRIO TÉCNICO'
              : 'NOVO RELATÓRIO TÉCNICO'}
          </h1>

          <ul>
            <Row>
              <Column>
                <strong>Relatórios Técnicos</strong>
                <Select
                  styles={SelectStyled}
                  id="technicalReport"
                  value={values.technicalReport}
                  placeholder="Selecione um Relatório Técnico"
                  onChange={selectedOption =>
                    setFieldValue('technicalReport', selectedOption)
                  }
                  isSearchable
                  options={technicalReports}
                  getOptionLabel={item =>
                    `${new Date(item.createdAt).toLocaleDateString(
                      'pt-BR'
                    )} - ${item.employee?.name} - ${item.description}`
                  }
                  getOptionValue={item => item.uuid}
                  name="technicalReport"
                  isLoading={false}
                  menuPlacement="auto"
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  loadingMessage={() => 'Buscando Relatórios Técnicos'}
                  noOptionsMessage={() => 'Não há Relatórios Técnicos'}
                />
                {errors.technicalReport && touched.technicalReport && (
                  <span>{errors.technicalReport}</span>
                )}
              </Column>
            </Row>
            <Row>
              <div className="buttons-container">
                <button type="submit" disabled={isSubmitting}>
                  SALVAR
                </button>

                <button
                  type="button"
                  onClick={handleReset}
                  disabled={!dirty || isSubmitting}
                >
                  RESET
                </button>

                {maintenanceTechnicalReport && (
                  <button
                    type="button"
                    onClick={onNew}
                    disabled={
                      (!dirty && !maintenanceTechnicalReport) || isSubmitting
                    }
                  >
                    LIMPAR
                  </button>
                )}
              </div>
            </Row>
          </ul>
        </FormStyled>
      )}
    </Formik>
  );
};

MaintenanceTechnicalReportForm.propTypes = {
  technicalReports: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  technicalReport: PropTypes.shape({
    uuid: PropTypes.string,
    name: PropTypes.string,
  }),
  MaintenanceTechnicalReportForm: PropTypes.shape({
    start: PropTypes.string,
    end: PropTypes.string,
    employee: PropTypes.shape({
      uuid: PropTypes.string,
      name: PropTypes.string,
    }),
  }),
  onNew: PropTypes.func.isRequired,
};

MaintenanceTechnicalReportForm.defaultProps = {
  technicalReports: [],
  employee: null,
  maintenanceEmployee: null,
};

export default MaintenanceTechnicalReportForm;
